<template>
  <div class="scope-load-progress">
    <div class="scope-load-progress-value">
      Loading your family...<span v-if="personCount">{{ Math.round(personCountDisplay) }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.scope-load-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 2rem 0;

  .scope-load-progress-value {
    font-size: 0.9rem;
    color: #888;
    font-variant-numeric: tabular-nums;
  }
}
</style>

<script lang="ts" setup>
import { computed } from 'vue'
import { useTransition, TransitionPresets } from '@vueuse/core'
import { useExploreStore } from '@/explore/ExploreStore'
import { useViewScopeStore } from '@/explore/ViewScopeStore'

const exploreStore = useExploreStore()
const viewScopeStore = useViewScopeStore()

const progressRef = computed(() => viewScopeStore.loadProgress.get(exploreStore.startPersonId ?? ''))
const personCount = computed(() => progressRef.value?.totalPersons ?? 0)
const personCountDisplay = useTransition(personCount, { duration: 500, transition: TransitionPresets.easeOutCubic })
</script>
